export default {
  created () {
    this.filters = this._defaultFilters()
  },
  data () {
    return {
      filters: {}
    }
  },
  methods: {
    _defaultFilters () {
      return {}
    }
  }
}
